import { cn } from '@/lib/utils';
import { PageContentGridProps } from './types';

const PageContentGrid = (props: PageContentGridProps) => {
  const {
    aside,
    asideClassName,
    children,
    className,
    contentClassName
  } = props;

  return (
    <div className={cn('min-[769px]:grid min-[769px]:grid-cols-[minmax(0,1fr)_340px] min-[769px]:gap-8', className)}>
      <div className={cn('flex min-w-0 flex-col gap-8', contentClassName)}>
        {children}
      </div>
      {aside && (
        <aside
          className={cn(
            'min-[769px]:sticky min-[769px]:top-4 hidden',
            'min-[769px]:flex min-[769px]:flex-col min-[769px]:gap-8 min-[769px]:self-start',
            asideClassName
          )}
        >
          {aside}
        </aside>
      )}
    </div>
  );
};

export default PageContentGrid;